export default {
  mounted() {
    this.$snowplow.refreshLinkClickTracking();
  },
};
